module.exports = __webpack_public_path__ + "img/GT.Earthworks.Cut.Exported.083eaf83.png";